import React, { useState } from "react";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";
import { PWA } from "@/constants/testIds";
import { TESTIMONIALS } from "./data";
import Reveal from "./Reveal";

const Testimonials = () => {
  const [idx, setIdx] = useState(0);
  const t = TESTIMONIALS[idx];
  const prev = () => setIdx((i) => (i - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
  const next = () => setIdx((i) => (i + 1) % TESTIMONIALS.length);

  return (
    <section
      id="testimonials"
      data-testid={PWA.testimonialsSection}
      className="relative bg-[#F1ECE0] py-24 md:py-32"
    >
      <div className="w-full max-w-6xl mx-auto px-6 md:px-10 lg:px-14">
        <Reveal>
          <p className="text-[11px] tracking-[0.4em] uppercase text-[#5C4033] font-semibold mb-5 text-center">
            — Client Stories
          </p>
        </Reveal>
        <Reveal delay={120}>
          <h2 className="font-serif-display text-[#1A1A1A] text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-center">
            Words from <span className="italic text-[#5C4033]">happy homes.</span>
          </h2>
        </Reveal>

        <Reveal delay={220}>
          <div className="mt-16 relative">
            <Quote className="absolute -top-6 left-0 md:-left-4 w-16 h-16 text-[#5C4033]/15" />
            <blockquote className="font-serif-display text-2xl md:text-4xl lg:text-[44px] leading-[1.25] text-[#1A1A1A] text-center max-w-4xl mx-auto px-4">
              "{t.quote}"
            </blockquote>
            <div className="mt-10 flex flex-col items-center">
              <div className="h-px w-16 bg-[#C19A6B] mb-5" />
              <p className="text-[#1A1A1A] font-semibold tracking-wide">{t.name}</p>
              <p className="mt-1 text-[11px] tracking-[0.32em] uppercase text-[#5C4033] font-semibold">
                {t.project} · {t.location}
              </p>
            </div>
          </div>
        </Reveal>

        <div className="mt-14 flex items-center justify-center gap-4">
          <button
            data-testid={PWA.testimonialPrev}
            onClick={prev}
            aria-label="Previous testimonial"
            className="w-12 h-12 border border-[#1A1A1A]/20 text-[#1A1A1A] hover:bg-[#1A1A1A] hover:text-[#FAF9F6] transition-colors flex items-center justify-center"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          <div className="flex gap-2">
            {TESTIMONIALS.map((_, i) => (
              <button
                key={i}
                onClick={() => setIdx(i)}
                aria-label={`Go to testimonial ${i + 1}`}
                data-testid={`pwa-testimonial-dot-${i}`}
                className={`h-1.5 transition-all ${
                  i === idx ? "w-10 bg-[#5C4033]" : "w-5 bg-[#1A1A1A]/20"
                }`}
              />
            ))}
          </div>
          <button
            data-testid={PWA.testimonialNext}
            onClick={next}
            aria-label="Next testimonial"
            className="w-12 h-12 border border-[#1A1A1A]/20 text-[#1A1A1A] hover:bg-[#1A1A1A] hover:text-[#FAF9F6] transition-colors flex items-center justify-center"
          >
            <ChevronRight className="w-5 h-5" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
